module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTY1OS44IDk2OS45IDM2My43IDk2OS45IDM2My43IDY0NC43IDMzLjYgNzYuOGwzMjUuMiAwIDE1NS4zIDMwMUw2NjkuNSA3Ni44IDk4OS44IDc2LjggNjU5LjggNjM5LjggNjU5LjggOTY5Ljl6IiBmaWxsPSIjMjMxODE1IiBwLWlkPSI1OTUiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/y.svg
// module id = qKPf
// module chunks = 73